import { Radius } from '@picsart/cascade';
import { createUseStyles } from 'react-jss';

import { ITheme } from 'types';

const useStyles = createUseStyles((theme: ITheme) => ({
  formatButton: {
    height: 56,
    borderRadius: Radius.r8,
    borderStyle: 'solid',
    borderColor: theme.colors.texts.tint1,
    minWidth: 'auto',
  },
  activeFormatButton: {
    borderWidth: 2,
    borderColor: theme.colors.accents.primary.base.default,
  },
}));

export default useStyles;
